const BEHAVIOUR_URL = `${process.env.REACT_APP_BEHAVIOUR}mvp_log/log`;
const API_KEY = '4ba4dc27-f800-44f3-8576-bbb42826d8f4';

export async function shareLibraryResource(body) {
    const site = window.location.href;
    const email = window.personal_email;

    try {
        await fetch(BEHAVIOUR_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'api-key': API_KEY,
            },
            body: JSON.stringify({
                site: site,
                email: email,
                action: 'biblioteca_compartir_recurso',
                detail: JSON.stringify(body),
            }),
        });
    } catch (error) {
        console.error('Error BEHAVIOUR share library resource:', error);
        return error;
    }
}
